export default __webpack_public_path__ + "static/media/info-square-icon.dc8536a8.svg";